import { useState } from 'react'
import { Text } from 'shared/components/Text/Text'

import { isConsole } from '../../../config/config'
import { addNoonToDate, formatDate } from '../../../helpers/formatters'
import { User } from '../../../models/user'
import { ProfileCard, ProfileCardItem } from './ProfileCard'
import { ProfilePersonalInfoEdit } from './ProfilePersonalInfoEdit'
import { ProfileSSN } from './ProfileSSN'

interface ProfilePersonalInfoProps {
  user: User
  canEdit: boolean
}

export function ProfilePersonalInfo({ user, canEdit }: ProfilePersonalInfoProps) {
  const [editMailingAddress, setEditMailingAddress] = useState(false)
  const address = user.shippingAddress!

  return (
    <>
      <ProfileCard title="Personal info" onEdit={canEdit ? () => setEditMailingAddress(true) : undefined}>
        {isConsole() && <ProfileSSN user={user} canEdit={canEdit} />}
        <ProfileCardItem label="Date of birth">
          {user.driver?.dob ? formatDate(addNoonToDate(user.driver?.dob)) : '-'}
        </ProfileCardItem>
        <ProfileCardItem label="Mailing Address">
          {address ? (
            <>
              <Text variant="label2" fontColor="inherit">
                {address.line1}
              </Text>
              {address.line2 && (
                <Text variant="label2" fontColor="inherit">
                  {address.line2}
                </Text>
              )}
              <Text
                variant="label2"
                fontColor="inherit"
              >{`${address.city}, ${address.state} ${address.zip}`}</Text>
            </>
          ) : (
            '-'
          )}
        </ProfileCardItem>
      </ProfileCard>

      {editMailingAddress && (
        <ProfilePersonalInfoEdit user={user} handleClose={() => setEditMailingAddress(false)} />
      )}
    </>
  )
}
